import { PLOT_DATA_CLEARED } from '../../actionTypes/componentConfig';
var clearPlotData = function clearPlotData(plotUuids) {
  return function (dispatch) {
    dispatch({
      type: PLOT_DATA_CLEARED,
      payload: {
        plotUuids: plotUuids
      }
    });
  };
};
export default clearPlotData;